import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WaterProvider } from "../misc";

import { faXmarkCircle } from "@fortawesome/pro-regular-svg-icons/faXmarkCircle";
import styles from "./ProviderInfoHeader.module.scss";
import { useUpdateHeights } from "../../Components/hooks";
import ReactResizeDetector from "react-resize-detector";

interface LProviderInfoHeaderProps {
    provider?: WaterProvider;
    className?: string;
    enabledHeightWatching?: boolean;
    onRemove?: () => void;
}

export const HEIGHT_WATCHING_LINE_2 = "height_watching_line_2";
export const HEIGHT_UPDATE_LINE_2 = "height_update_line_2";

const LProviderInfoHeader: React.FC<LProviderInfoHeaderProps> = ({
    provider,
    className,
    enabledHeightWatching,
    onRemove
}) => {
    const ref = useRef();
    const updateHeightsForLine1 = useUpdateHeights(
        enabledHeightWatching,
        ref,
        `.${HEIGHT_WATCHING_LINE_2}`,
        `.${HEIGHT_UPDATE_LINE_2}`
    );

    useEffect(() => {
        enabledHeightWatching && updateHeightsForLine1();
    }, [provider, enabledHeightWatching, updateHeightsForLine1]);

    if (!provider) return null;

    const { name } = provider;

    return (
        <div className={`col-12 ${className}`} ref={ref}>
            <div className={`${HEIGHT_UPDATE_LINE_2} ${styles.heightWatching}`}>
                <h2 className={`${styles.title}`}>
                    <span className={HEIGHT_WATCHING_LINE_2}>{name}</span>

                    {onRemove != null && (
                        <span className={styles.remove}>
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                onClick={() => {
                                    onRemove();
                                }}
                            />
                        </span>
                    )}
                </h2>
            </div>

            {enabledHeightWatching === true && (
                <ReactResizeDetector handleWidth={true} handleHeight={true} onResize={updateHeightsForLine1} />
            )}
        </div>
    );
};

export const ProviderInfoHeader = React.memo(LProviderInfoHeader, (prev, next) => {
    return prev?.provider === next?.provider && prev?.className === next?.className && prev.onRemove === next.onRemove;
});
